import React, { useEffect, useState } from 'react';
import { getInstallPromptEvent, showInstallPrompt, isInstallPromptAvailable } from '../utils/pwaInstall';
import './InstallPWA.css';

const InstallPWA = () => {
  const [, setInstallAvailable] = useState(false);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone
      || document.referrer.includes('android-app://');
    setIsStandalone(isStandaloneMode);

    const iosDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iosDevice);

    const bannerDismissed = localStorage.getItem('pwa-install-banner-dismissed');
    const hasShownBanner = localStorage.getItem('pwa-install-banner-shown');

    const onInstallAvailable = () => {
      setInstallAvailable(true);
      if (!isStandaloneMode && !bannerDismissed) {
        setShowInstallBanner(true);
      }
    };

    if (isInstallPromptAvailable()) {
      onInstallAvailable();
    }

    window.addEventListener('pwa-install-available', onInstallAvailable);

    if (iosDevice && !isStandaloneMode && !bannerDismissed && !hasShownBanner) {
      const timer = setTimeout(() => {
        setShowInstallBanner(true);
        localStorage.setItem('pwa-install-banner-shown', 'true');
      }, 2500);

      return () => {
        clearTimeout(timer);
        window.removeEventListener('pwa-install-available', onInstallAvailable);
      };
    }

    return () => window.removeEventListener('pwa-install-available', onInstallAvailable);
  }, []);

  const handleInstallClick = async () => {
    if (!getInstallPromptEvent()) {
      alert('Para instalar o app, use o menu do navegador e selecione "Adicionar a tela inicial" ou "Instalar app".');
      return;
    }

    try {
      const result = await showInstallPrompt();
      if (result?.outcome === 'accepted') {
        localStorage.setItem('pwa-install-banner-dismissed', 'true');
      }
      setShowInstallBanner(false);
    } catch (error) {
      console.error('Erro ao mostrar prompt de instalacao:', error);
      setShowInstallBanner(false);
    }
  };

  const handleDismiss = () => {
    setShowInstallBanner(false);
    localStorage.setItem('pwa-install-banner-dismissed', 'true');
  };

  if (isStandalone || !showInstallBanner) {
    return null;
  }

  return (
    <div className="install-pwa-banner">
      <div className="install-pwa-content">
        <div className="install-pwa-icon" aria-hidden="true">GEM</div>
        <div className="install-pwa-text">
          <strong>{isIOS ? 'Instalar o SisGEM no iPhone' : 'Instalar o SisGEM'}</strong>
          <p>
            {isIOS
              ? 'Toque em Compartilhar e depois em "Adicionar a Tela de Inicio".'
              : 'Abra mais rapido, em tela cheia, e continue acessando o app mesmo com rede ruim.'}
          </p>
        </div>
        {!isIOS && (
          <button
            className="btn-install-pwa"
            onClick={handleInstallClick}
          >
            Instalar
          </button>
        )}
        <button
          className="btn-dismiss-pwa"
          onClick={handleDismiss}
          aria-label="Fechar"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default InstallPWA;
